import React from "react";
import PhoneNumberRenderer from "./PhoneNumberRenderer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class PrivacyRendererEmail extends React.Component<any>
{
    render(): React.ReactNode
    {
        return <div className="grayText">{this.props.value.toLowerCase()}
            <OverlayTrigger
                key="privacy"
                placement={"top"}
                overlay={
                    <Tooltip id={`tooltip-top`}>
                        <strong>Field supressed in MIT directory</strong>.
                    </Tooltip>
                }>
                <span>&nbsp;<i className="far fa-eye"></i>&nbsp;Suppressed</span>
            </OverlayTrigger>
        </div>;
    }
}
